// extracted by mini-css-extract-plugin
module.exports = {"displayValue":"displayValue_displayValue__2pl0u","label":"displayValue_label__33de-","block":"displayValue_block__2s5MJ","multiValues":"displayValue_multiValues__32WMJ"};